import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import VideoTrackViewerNew from "features/robot-teleop/components/video-viewer/VideoTrackViewerNew";
import { message } from "antd";
import { useServerConnection } from "shared/contexts/ServerConnectionContext";
import { useRobotPeerConnection } from "features/robot-teleop/contexts/RobotConnectionContext";
import RobotConnectionStatus from "features/robot-teleop/components/robot-status/status-ctx/robot-connection-status";

const PageRobotCamera = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const qsShowDelayGraph =
    searchParams.has("show-delay") &&
    searchParams.get("show-delay").trim().toLocaleLowerCase() == "true";

  const qsShowStatus = searchParams.has("show-status")
    ? searchParams.get("show-status").trim().toLocaleLowerCase() == "true"
    : false;

  console.log("qsShowStatus: ", qsShowStatus);

  const qsCamWidth = searchParams.has("cam-width")
    ? searchParams.get("cam-width")
    : "100%";
  const qsCamHeight = searchParams.has("cam-height")
    ? searchParams.get("cam-height")
    : "95vh";
  console.log("camwidth: ", qsCamWidth);

  const [messageApi, contextHolder] = message.useMessage();

  const { id } = useParams();

  const {
    setRobotId,
    connectionState: rtcConnectionState,
    mediaTracks,
    channelMessage,
    channelSend,
    connect,
    // close: closePeerConnection,
    error,
    robotOnlineStatus,
    setStatsEnabled,
    addChannelMessageReceivedEventListener,
  } = useRobotPeerConnection();

  const [robotStatus, setRobotStatus] = useState(null);
  const [robotErrorInfo, setRobotErrorInfo] = useState(null);
  const [missionStatus, setMissionStatus] = useState(null);

  useEffect(() => {
    setRobotId(id);
    const unlisten =
      addChannelMessageReceivedEventListener(handleChannelMessage);
    return () => {
      unlisten();
    };
  }, [id]);

  useEffect(() => {
    setStatsEnabled(qsShowDelayGraph);
  }, [qsShowDelayGraph]);

  const handleChannelMessage = (channelMessage) => {
    if (!channelMessage) return;
    if (channelMessage.channel == "chat") {
      const data = JSON.parse(channelMessage.data);
      const msg_type = data["msg_type"];

      if (msg_type == "robot_state") {
        const msg_body = data["msg_body"];
        let robotInfo = msg_body["common_info"];
        const errorInfo = msg_body["error_info"];
        const missionInfo = msg_body["mission_info"];
        // robotInfo["icon"] = "/images/gocart.jpg";
        robotInfo["error_info"] = errorInfo;
        // console.log("robotInfo: ", robotInfo);
        // TODO: check map

        setRobotErrorInfo(errorInfo);
        setRobotStatus(robotInfo);
        setMissionStatus(missionInfo);
      }
    }
  };

  const divStyle = { width: qsCamWidth, height: qsCamHeight };
  console.log("divStyle: ", divStyle);

  const mainDivStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // height: "100vh",
    width: "100%",
    margin: "0",
  };
  return (
    <div style={mainDivStyle}>
      <div>
        <RobotConnectionStatus
          ShowAlert={true}
          ShowStatus={qsShowStatus}
          Vertical={false}
        ></RobotConnectionStatus>

        <div
        // style={divStyle}
        >
          {contextHolder}
          <VideoTrackViewerNew
            CameraStyle={{ height: qsCamHeight, width: qsCamWidth }}
            mediaTracks={mediaTracks}
            ShowDelayTime={qsShowDelayGraph}
          ></VideoTrackViewerNew>
        </div>
      </div>
    </div>
  );
};

export default PageRobotCamera;
